import enFlag from "./flagSvg/gb.svg";
import plFlag from "./flagSvg/pl.svg";
import usFlag from "./flagSvg/us.svg";

const availableLanguages = [
  {
    language: "GB",
    name: "English - GB",
    flagImg: enFlag,
  },
  {
    language: "US",
    name: "English - US",
    flagImg: usFlag,
  },
  {
    language: "pl",
    name: "Polski",
    flagImg: plFlag,
  },
] as const;

export default availableLanguages;
